import axios from 'axios';

function resolveApiBaseUrl() {
  const configured = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (!configured || configured === 'undefined') {
    return '/api';
  }
  return `${configured}/api`;
}

function looksLikeHtmlPayload(data) {
  return typeof data === 'string' && /^\s*</.test(data);
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mayr_ops_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const contentType = response.headers?.['content-type'] || '';
    if (looksLikeHtmlPayload(response.data) || (!contentType.includes('json') && looksLikeHtmlPayload(String(response.data || '')))) {
      return Promise.reject(Object.assign(new Error('Unexpected non-JSON API response'), { response }));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isLaunchpad = requestUrl.includes('/launchpad/');
      const pathname = window.location.pathname;
      if (!isLaunchpad && pathname !== '/login') {
        localStorage.removeItem('mayr_ops_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
